import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { LoginApis } from '../../API/Login/LoginApi.js'
import ErrorHandle from '../../Components/ErrorHandle.js'
import Loader from '../../Components/Loader/Loader.js'
import Toasts from '../../Components/Toasts/Toasts.js'
import { setSearchFriends } from '../../store/reducers/Users/users.js'
import { dispatch } from '../../store/reducers/persist.js'
import SearchPagination from '../SearchFriend/pagination.js'
import ListCard from '../../Components/Events/ListCard.jsx'
import { getCategoryLabel } from '../../utils/Constent.js'
import { useNavigate } from 'react-router'

const EventSearchResults = (props) => {
  const navigate = useNavigate()
  // const location = useLocation();
  const { state } = useLocation()
  const searchData =
    state?.search ||
    JSON.parse(localStorage.getItem("search")) ||
    {};
  // const searchData = localStorage.getItem("search");
  const { frProUser } = useSelector(
    (state) => state.Users
  )

  const [showLoading, setshowLoading] = useState(false)
  const [friendsList, setfriendsList] = React.useState([])
  const [searchRes, setsearchRes] = React.useState([])
  const [toasts, setToasts] = useState(null)

  const [page, setPage] = useState(1)
  const [totalPages, settotalPages] = useState(1)

  const size = 3

  const SearchDataList = () => {
    setfriendsList([]);

    let searchFriendObj = {
      "searchText": searchData?.searchText,
      "searchType": searchData?.searchType,
      "userId": frProUser?.userId,
      "fre8ProAccessToken": frProUser?.fre8ProAccessToken,
      "page": page,
      "size": size,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE
    }
    let headers = {
      "Authorization": `Bearer:${localStorage.getItem("Authorization")}`
    }
    LoginApis.searchFriend(searchFriendObj, headers)
      .then((res) => {
        setsearchRes(res?.data)
        setfriendsList(res?.data?.formList)
        settotalPages(res?.data?.totalRecords)
      })
      .catch((err) => {
        console.log('Search::Error seach friend', err)
        let customMessage = 'Search request not found'
        let type = 'Search'
        let color = 'red'
        ErrorHandle(err, setToasts, customMessage, type, color)
      })
      .finally(() => {
        setshowLoading(false)
      })
  }

  // const { results, isLoading, goToNextPage, goToPreviousPage, updateQuery } = useSearchPagination(SearchDataList, "", 5);
  // console.log("useSearchPagination::::::", results, isLoading, goToNextPage, goToPreviousPage, updateQuery)

  useEffect(() => {
    SearchDataList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchData])


  React.useEffect(() => {
    let promiseObjToLoadImage = friendsList?.map((friend) => {
      let data = loadImage(friend)

      friend = data
      // frndList.push(data);
      return data
    })
    setTimeout(() => {
      promiseObjToLoadImage.length > 0 && Promise.all(promiseObjToLoadImage)
        .then((res) => {
          if (res) {
            dispatch(
              setSearchFriends({
                searchFriendsResults: res,
              })
            )
          }
        })
        .catch((err) => {
          if (!err?.response?.data?.success) {
            // let item = [
            //   {
            //     name: err?.response?.data?.errorDetail?.developerMessage,
            //     type: err?.response?.data?.errorDetail?.errorType,
            //   },
            // ];
            // setShowSuccess(true)
            // setToasts(item);
            // setTimeout(() => {
            //   navigate('/')
            // }, 4000);
          }
        })

    }, 1000)
  }, []) //eslint-disable-line

  const loadImage = (friendVal) => {
    // let loogedInUser = JSON.parse(localStorage.getItem('user'))
    return new Promise((resolve, reject) => {
      let friend = friendVal
      let objSearchImg = {

        "fre8ProAccessToken": frProUser?.fre8ProAccessToken,
        "operatedByModule": "FRE8PRO",
        "operatedByUserId": frProUser?.userId,//Loggedinuserid
        "profileId": friend?.profileId, //searcheduserid
        "userId": friend?.userId, //searcheduserid
        "profileImageId": "",
        "imgOriginalName": "",
        "imgGeneratedName": "",
        "description": "",

        "uploadedAtString": "",
        "profileImageUrl": "",
        "profileImageUrlList": [
          "",
          ""
        ],
        "profileImageUrls": {
          "in_3e_": "",
          "dolor_8": ""
        }

      }
      LoginApis.getImageForOtherUser(objSearchImg)
        .then((res) => {

          let imageData = {
            userProfileImgUrlData: res?.data?.profileImageUrlList,
          }
          let merged = { ...friend, ...imageData }
          resolve(merged)

        })
        .catch((err) => {
          // resolve(friend)
        })

      console.log("Load image for others", objSearchImg, frProUser, friend)
    })
  }

  return (
    <>
      <main className="main users chart-page" id="skip-target">
        <div className="container-fluid p-lg-4">
          <div className="bckaarw my-3">
            <Link to="" onClick={() => navigate(-1)} className="p-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none">
                <path
                  d="M15.8334 10H4.16669M4.16669 10L10 15.8334M4.16669 10L10 4.16669"
                  stroke="#667085"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="ms-1">Go back</span>
            </Link>
          </div>
          <div className="p-0 mb-4">
            <h2 className="main-title">
              Search Results For {searchData?.searchType}
            </h2>
          </div>

          {showLoading && <Loader />}
          <div className="row">
            <div className={`col-md-12`}>
              <div className="box-2">
                <div className="filterheadung-2 mb-2">
                  {friendsList?.length || 0} results found
                </div>
                {friendsList?.length === 0 && (
                  <div className="filterheadung-2 mb-2">
                    0 results found, try again or,
                    <span className="clear">clear your filters</span>
                  </div>
                )}
                <div className="People">
                  <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
                    <p className="text-center heading-according-to-info">
                      People and businesses
                    </p>
                    <div className="row g-3">
                      {friendsList?.length > 0 && friendsList?.map((item, i) => {
                        const categoryLabel = getCategoryLabel(item?.eventCategory)
                        // {friendsList?.map((item, i) => (
                        return <ListCard
                          key={i}
                          categoryLabel={categoryLabel}
                          item={item}
                          setToasts={setToasts}
                          eventCategory={'all'}
                          page={page}
                        />

                      })}
                      {/* handleIndividualEventImages={handleIndividualEventImages} */}
                      {/* handleChangeTab={handleChangeTab} */}
                      {/* {allEventsList?.map((item, key) => {
                                  const categoryLabel = getCategoryLabel(item?.eventCategory)
                                  console.log('--------item----->', item)
                                  console.log('--------categoryLabel----->', categoryLabel)
                                  return (
                                    <ListCard
                                      key={key}
                                      categoryLabel={categoryLabel}
                                      item={item}
                                      handleIndividualEventImages={handleIndividualEventImages}
                                      setToasts={setToasts}
                                      handleChangeTab={handleChangeTab}
                                      eventCategory={'all'}
                                      page={page}
                                    />
                                  )
                                })} */}
                    </div>
                  </div>
                </div>
                {/* Pagination */}
                <SearchPagination
                  page={page}
                  setPage={setPage}
                  totalPages={Math.ceil(totalPages / size)}
                  searchRes={searchRes}
                />
              </div>
            </div>
          </div>
        </div>
        {toasts && <Toasts toastsList={toasts} />}
      </main>
    </>
  )
}

export default EventSearchResults